import * as React from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Stimulsoft } from 'stimulsoft-reports-js/Scripts/stimulsoft.viewer';
import { GetQuery, PostFormDataQuery } from './Shared';

const ReportViewerData = () => {
    const { name, param1, param2, param3, param4, param5 } = useParams();
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {

        if (name != "") {
            getData();
        }
    }, []);


    const getData = async () => {
        const baseURL = window.location.origin;
        var apiUrl = "Get" + name + "Data?param1=" + param1 + "&param2=" + param2 + "&param3=" + param3 + "&param4=" + param4 + "&param5=" + param5;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                setLoading(false);

                var options = new Stimulsoft.Viewer.StiViewerOptions();
                options.toolbar.showSendEmailButton = true;
                options.exports.showExportToCsv = false;
                options.exports.showExportToDocument = false;
                options.exports.showExportToExcel = false;
                options.exports.showExportToHtml = false;
                options.exports.showExportToHtml5 = false;
                options.exports.showExportToImageSvg = false;
                options.exports.showExportToJson = false;
                options.exports.showExportToOpenDocumentCalc = false;
                options.exports.showExportToOpenDocumentWriter = false;
                options.exports.showExportToPowerPoint = false;
                options.exports.showExportToText = false;
                options.exports.showExportToWord = false;

                var viewer = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);

                //console.log('Creating a new report instance');
                var report = new Stimulsoft.Report.StiReport();
                var reportFile = Stimulsoft.System.IO.File.getFile(baseURL + "/reports/" + result.data.reportFileName);
                report.load(reportFile);

                var reportData = JSON.stringify(result.data.reportData);
                //Dataset created
                var dataSet = new Stimulsoft.System.Data.DataSet("data");
                dataSet.readJson(reportData)
                report.regData(dataSet.dataSetName, "", dataSet);
                report.reportName = result.data.reportName;
                report.dictionary.connect(false);
                report.dictionary.synchronize();

                //add relationships between data
                for (var i = 0; i < result.data.reportRelationships.length; i++) {
                    var dataRelation = new Stimulsoft.Report.Dictionary.StiDataRelation(result.data.reportRelationships[i].sourceName, result.data.reportRelationships[i].name, result.data.reportRelationships[i].alias, report.dictionary.dataSources.getByName(result.data.reportRelationships[i].parentTableName), report.dictionary.dataSources.getByName(result.data.reportRelationships[i].childTableName), [result.data.reportRelationships[i].parentFieldName], [result.data.reportRelationships[i].childFieldName]);
                    report.dictionary.relations.add(dataRelation);
                    report.dictionary.synchronize();
                }

                viewer.report = report;
                viewer.onEmailReport = onEmailReport;
                viewer.renderHtml('viewer');
            }
        }
    }

    const onEmailReport = async function (args: any) {
        // args.settings -  send email form
        // args.settings.email  -  email adress
        // args.settings.subject  -  email subject
        // args.settings.message  -  email message
        // args.formatName  -  export format - PDF, HTML, HTML 5, Excel2007, Word2007, CSV
        // args.fileName - report file name (name of attachement)
        // args.data  -  byte array with exported report file

        var fileData = [new Uint8Array(args.data)];
        var reportFile = new File(fileData, args.fileName, { type: 'application/pdf' });

        const emaildata = new FormData()
        emaildata.append('emailTo', args.settings.email);
        emaildata.append('subject', args.settings.subject);
        emaildata.append('message', args.settings.message);
        emaildata.append('report', reportFile);

        const apiUrl = "EmailReport";
        var result = await PostFormDataQuery(apiUrl, emaildata);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Report has been emailed");
            }
        }
    }

    const renderDetails = (
        <div id="viewer"></div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );
}

export default ReportViewerData;
